import axiosInstance from '@/lib/axios';



// ✅ Set user sport preferences
export async function setSportPreference(data) {
  try {

    const response = await axiosInstance.patch('/users/preferences', data);
    return response.data;
  } catch (error) {
    const errData = error.response?.data;
    const message = errData?.detail || JSON.stringify(errData) || error.message;
    throw new Error('Failed to update profile: ' + message);
  }
}

export async function getUserPreference() {
  try {
    const response = await axiosInstance.get('/users/preferences'
    );
    return response.data;
  } catch (error) {
    throw new Error('Failed to load preference');
  }
}

// ✅ Fetch all available sports
export async function fetchAvailableSports() {
  try {
    const response = await axiosInstance.get('/users/preferences/sports'
    );
    return response.data;
  } catch (error) {
    throw new Error('Failed to load preference');
  }
}